import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/org/$orgSlug/portal/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/org/$orgSlug/portal/knowledge-base',
      params: { orgSlug: params.orgSlug },
    });
  },
});